var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRads(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#9d4bef",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.47 7.661a3.808 3.808 0 110 7.616 3.808 3.808 0 010-7.616zm3.807 12.87a3.808 3.808 0 11-3.808-3.808 5.253 5.253 0 005.253-5.253 3.808 3.808 0 113.808 3.808 5.253 5.253 0 00-5.252 5.253zm5.253 3.808a3.808 3.808 0 110-7.616 3.808 3.808 0 010 7.616zm0-2.66a1.148 1.148 0 100-2.296 1.148 1.148 0 000 2.296zm-9.06 0a1.148 1.148 0 100-2.296 1.148 1.148 0 000 2.296zm9.06-9.062a1.148 1.148 0 100-2.296 1.148 1.148 0 000 2.296zm-9.06 0a1.148 1.148 0 100-2.296 1.148 1.148 0 000 2.296z",
    fill: "#fff",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRads);
export default __webpack_public_path__ + "static/media/rads.a84b77e8ad2db44e49d2afbae2f7567d.svg";
export { ForwardRef as ReactComponent };